import React, { Component, createRef } from 'react';
import { NavLink } from 'react-router';

import { Sidebar }    from 'primereact/sidebar';
import { Avatar }     from 'primereact/avatar';
import { Button }     from 'primereact/button';
import { Ripple }     from 'primereact/ripple';
import { StyleClass } from 'primereact/styleclass';

import { UtilService } from 'hay-core-react';
import IconeHay     from '../../images/logo-loading.png';
import { withRouter } from 'hay-core-react';
class AppSidebar extends Component {

    constructor(props) {
        super(props);
        this.btnRef1   = createRef();
        this.grupoRefs = {};
        this.sair = this.sair.bind(this);
    }

    getGrupoRef(key) {
        if (!this.grupoRefs[key]) this.grupoRefs[key] = createRef();
        return this.grupoRefs[key];
    }

    sair() {
        UtilService.efetuarLogout();
    }

    render() {
        const { auth, menuItems, visible, onHide, navigate } = this.props;

        return (
            <Sidebar
                visible={visible}
                onHide={onHide}
                modal={true}
                showCloseIcon={false}
                dismissable={true}
                closeOnEscape={true}
                position="left"
                style={{ width: '280px' }}
                pt={{
                    root:    { style: { position: 'relative', height: '100%' } },
                    content: { style: { padding: 0 } },
                }}
                content={() => (
                    <div className="min-h-screen flex relative lg:static surface-ground">
                        <div
                            className="surface-section h-screen block flex-shrink-0 absolute lg:static left-0 top-0 z-1 border-right-1 surface-border select-none"
                            style={{ width: '280px' }}
                        >
                            <div className="flex flex-column h-full">

                                {/* ── Cabeçalho ───────────────────────────────── */}
                                <div className="flex align-items-center justify-content-between px-4 pt-3 flex-shrink-0">
                                    <span className="inline-flex align-items-center gap-2">
                                        <img src={IconeHay} alt="logo" width="35" height="35" />
                                        <span className="font-semibold text-2xl text-primary">{UtilService.traduzir('main.sistema.titulo')}</span>
                                    </span>
                                </div>

                                {/* ── Menu ────────────────────────────────────── */}
                                <div className="overflow-y-auto">
                                    <ul className="list-none p-3 m-0">
                                        <li>
                                            <StyleClass
                                                nodeRef={this.btnRef1}
                                                selector="@next"
                                                enterFromClassName="hidden"
                                                enterActiveClassName="slidedown"
                                                leaveToClassName="hidden"
                                                leaveActiveClassName="slideup"
                                            >
                                                <div ref={this.btnRef1} className="p-ripple p-3 flex align-items-center justify-content-between text-600 cursor-pointer">
                                                    <span className="font-medium">MENU</span>
                                                    <i className="pi pi-chevron-down"></i>
                                                    <Ripple />
                                                </div>
                                            </StyleClass>

                                            <ul className="list-none p-0 m-0 overflow-hidden">
                                                {menuItems.map(item => {
                                                    if (item.tipo === 'grupo') {
                                                        const ref = this.getGrupoRef(item.key);
                                                        return (
                                                            <li key={item.key}>
                                                                <StyleClass
                                                                    nodeRef={ref}
                                                                    selector="@next"
                                                                    enterFromClassName="hidden"
                                                                    enterActiveClassName="slidedown"
                                                                    leaveToClassName="hidden"
                                                                    leaveActiveClassName="slideup"
                                                                >
                                                                    <div ref={ref} className="p-ripple p-3 flex align-items-center justify-content-between text-600 cursor-pointer border-round hover:surface-100 transition-duration-150 transition-colors">
                                                                        <div className="flex align-items-center gap-2">
                                                                            <i className={item.icon}></i>
                                                                            <span className="font-medium">{item.label}</span>
                                                                        </div>
                                                                        <i className="pi pi-chevron-down text-xs"></i>
                                                                        <Ripple />
                                                                    </div>
                                                                </StyleClass>
                                                                <ul className="list-none p-0 m-0 overflow-hidden pl-3">
                                                                    {item.itens.map(subItem => (
                                                                        <li key={subItem.path}>
                                                                            <NavLink
                                                                                to={subItem.path}
                                                                                className={({ isActive }) =>
                                                                                    'p-ripple no-underline flex align-items-center cursor-pointer p-3 border-round transition-duration-150 transition-colors w-full ' +
                                                                                    (isActive ? 'bg-primary text-white' : 'text-700 hover:surface-100')
                                                                                }
                                                                                onClick={e => { e.preventDefault(); navigate({ pathname: subItem.path }); onHide(); }}
                                                                            >
                                                                                <i className={`${subItem.icon} mr-2`}></i>
                                                                                <span className="font-medium">{subItem.label}</span>
                                                                                <Ripple />
                                                                            </NavLink>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </li>
                                                        );
                                                    }
                                                    return (
                                                        <li key={item.path}>
                                                            <NavLink
                                                                to={item.path}
                                                                className={({ isActive }) =>
                                                                    'p-ripple no-underline flex align-items-center cursor-pointer p-3 border-round transition-duration-150 transition-colors w-full ' +
                                                                    (isActive ? 'bg-primary text-white' : 'text-700 hover:surface-100')
                                                                }
                                                                onClick={e => { e.preventDefault(); navigate({ pathname: item.path }); onHide(); }}
                                                            >
                                                                <i className={`${item.icon} mr-2`}></i>
                                                                <span className="font-medium">{item.label}</span>
                                                                <Ripple />
                                                            </NavLink>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </li>
                                    </ul>
                                </div>

                                {/* ── Rodapé ──────────────────────────────────── */}
                                <div className="mt-auto">
                                    <hr className="mb-3 mx-3 border-top-1 border-none surface-border" />
                                    <div className="m-3 flex align-items-center p-3 gap-2 border-round text-700">
                                        <Avatar icon="pi pi-user" shape="circle" />
                                        <span className="font-bold" style={{ flex: 1, minWidth: 0, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{auth.nome}</span>
                                        <Button
                                            icon="pi pi-sign-out"
                                            severity="secondary"
                                            text
                                            rounded
                                            size="small"
                                            onClick={this.sair}
                                            tooltip={UtilService.traduzir('main.toolbar.sair')}
                                            tooltipOptions={{ position: 'top' }}
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                )}
            />
        );
    }
}

export default withRouter(AppSidebar);
